/**
 * Redux-enabled component for the video alert
 */

import { connect } from 'react-redux';

import { getLockState, getKeyboardHandlerId } from 'phoenix2/state/appstate/selectors';
import PureVideoAlert from './video.jsx';
import {
    FEATURE_FLAG_VIDEO_CHEAT_CODE,
    FEATURE_FLAG_SKILL_VIDEO_DISABLE_FINAL_FRAME_AT_START,
} from 'phoenix2/state/feature-flags';
import { getFeatureFlag } from 'phoenix2/state/feature-flags/selectors';
import { getIsStaffUser } from 'phoenix2/state/user/selectors';

const mapStateToProps = state => {
    // Determine whether to enable the video-skip cheat code for videos the
    // user is forced to watch:
    let enableCheatCode = getFeatureFlag(state, FEATURE_FLAG_VIDEO_CHEAT_CODE);

    // If the user is a teacher, always allow them to skip the video:
    const isStaffUser = getIsStaffUser(state);
    if (isStaffUser) {
        enableCheatCode = true;
    }

    // If the feature flag is not available, the default is false unless in the
    // development environment or environment for unit tests:
    if (enableCheatCode === undefined) {
        enableCheatCode = process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test';
    }

    // TODO: feature_flag: skill-video-disable-final-frame-at-start
    const disableFinalFrameAtStart = getFeatureFlag(
        state,
        FEATURE_FLAG_SKILL_VIDEO_DISABLE_FINAL_FRAME_AT_START,
    );

    return {
        forcePause: getLockState(state),
        keyboardHandlerId: getKeyboardHandlerId(state),
        enableCheatCode,
        disableFinalFrameAtStart,
    };
};

const connectVideoAlert = connect(mapStateToProps, null);

export const VideoAlert = connectVideoAlert(PureVideoAlert);
export default VideoAlert;
